import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { InlineAttachmentState } from 'owa-attachment-full-data';
import { AttachmentWellViewState } from 'owa-attachment-well-data';

export default function findAttachment(
    viewState: AttachmentWellViewState,
    options: {
        cidOrName?: string;
        tempId?: string;
    }
) {
    const inlineAttachments = viewState?.inlineAttachments || [];

    for (let i = 0; i < inlineAttachments.length; i++) {
        const attachment = getAttachment(inlineAttachments[i].attachmentId);

        if (
            attachment?.model &&
            (isCIDMatch(attachment.model, options.cidOrName) ||
                isTempIdMatch(inlineAttachments[i], options.tempId))
        ) {
            return attachment;
        }
    }

    return null;
}

function isCIDMatch(model: AttachmentType, cidOrName: string | undefined) {
    return cidOrName && (model.ContentId == cidOrName || model.Name == cidOrName);
}

function isTempIdMatch(attachment: InlineAttachmentState, tempId: string | undefined) {
    return tempId && attachment.placeholderId == tempId;
}
